import type { GatsbyBrowser } from "gatsby";
import "./src/styles/global.css";
import { AuthProvider } from "./src/context/AuthContext";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
);
